/***************************************************************************
 * 版權所有 (C) 2015, Rapid7 LLC, Boston, MA, USA。
 * 保留所有權利。本材料含有未發佈的、受版權保護的
 * 內容，包括 Rapid7 的機密和專有資訊。
 **************************************************************************/

/* jshint maxlen: false */
export default {
  insightvmNavMenus: {
    ftux: {
      back: '後退',
      cardLibrary: {
        content: {
          description:
            '製作自己的儀器板，專注於對您最重要的洞察分析。 為您的利益相關者編譯制定的視圖。',
        },
        title: '製作自己的視圖',
      },
      cards: {
        content: {
          description: '探索您的數據，並隨著您的綜合過濾能力的提高而細化。',
        },
        title: '擴展和過濾',
      },
      dashboards: {
        content: {
          description: '請嘗試使用特製的儀器板，針對您的需要提供合適的資訊。',
        },
        title: '儀器板函式庫',
      },
      end: '結束',
      endTour: '結束導覽',
      info: {
        description: '隨時透過此選單存取儀器板導覽。',
      },
      navigation: {
        content: {
          description: '透過直觀儀器板和視覺化技術，即時深入瞭解您的數據。',
        },
        title: '導航',
      },
      next: '下一個',
      ok: '確定',
      steps: '(從 __start__ 開始，在 __end__ 結束)',
      welcome: {
        content: {
          description:
            '體驗在下次掃描幾天前就能暴露漏洞的即時儀器板，以及。適應的工作流程，優先排序 IT 安全的必做事項。',
          header: '歡迎使用新版 Nexpose',
        },
        dismiss: '放棄',
        quickTour: '快速導覽',
      },
    },
    leftNav: {
      administration: '管理',
      assets: '資產',
      dashboard: '儀器板',
      home: '主頁',
      policies: '政策',
      projects: '項目',
      reports: '報表',
      tickets: '票證',
      vulnerabilities: '漏洞',
    },
    topNav: {
      assetGroup: '資產組',
      changePassword: '更改密碼',
      create: '建立',
      dynamicAssetGroup: '動態資產群組',
      help: '幫助',
      logoff: '註銷',
      report: '報表',
      search: '搜尋',
      site: '站點',
      support: '支援',
      tags: '標籤',
      tour: '導覽',
      userPreferences: '使用者偏好',
    },
  },
};
